export interface ApiConfig {
  url: string;
  headers: {
    [key: string]: string;
  };
}

export type PointGeometry = {
  coordinates: [number, number];
  type: 'Point';
};

export type LineStringGeometry = {
  coordinates: [number, number][];
  type: 'LineString';
};

export enum RoutingMethod {
  ECONOMY = 'ECONOMY',
  FAST = 'FAST',
  PRIORITY = 'PRIORITY',
  SHORT = 'SHORT'
}

export type Tariff = {
  external: number;
  infrastructure: number;
  netTotal: number;
  total: number;
  vat: number;
};
